import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripTagDetails({ label, options, count, onChange, isEditable }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={count}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
